import { CSSProperties } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import './FormGrid.scss';

interface IFormGridProps extends IChildrenProp {
  minWidth?: number;
}

const FormGrid = ({ children, minWidth }: IFormGridProps) => {
  return (
    <div
      className='form-grid'
      style={{ '--min-width': `${minWidth ?? 250}px` } as CSSProperties}>
      {children}
    </div>
  );
};

export default FormGrid;
